import React, { useMemo } from 'react';
import styled from '@emotion/styled';
import { useTheme, ThemeProvider } from '@emotion/react';
import { Title, Checkbox } from '..';
import { useComponentTheme } from '../useComponentTheme';

type Props = {
  label: string,
  id: string,
  name: string,
  value: string,
  selected: Boolean,
  toggleSelectItem: Function,
  isDisabled: Boolean,
  rightSide?: React.Node,
  children?: React.Node,
  footer?: React.Node,
};

const CheckListItem = ({
  label,
  id,
  name,
  value,
  selected,
  toggleSelectItem,
  isDisabled,
  rightSide,
  footer,
  children,
}: Props) => {
  const theme = useTheme();
  const componentTheme = useComponentTheme(theme => theme.components.CheckListItem);
  const componentThemeValue = useMemo(() => ({ componentTheme }), [componentTheme]);
  return (
    <ThemeProvider theme={componentThemeValue}>
      <Container theme={componentThemeValue}>
        <CheckboxWrapper
          id={id}
          name={name}
          value={value}
          checked={selected}
          disabled={isDisabled}
          onChange={() => toggleSelectItem(!selected)}
        />
        <CheckCardContent>
          <Header>
            <Title level={3} m={0} color={isDisabled ? theme.color.grey : null}>
              {label}
            </Title>
            {rightSide && <RightSide>{rightSide}</RightSide>}
          </Header>
          {children && <Content>{children}</Content>}
          {footer && componentTheme.Footer.visible && <Footer>{footer}</Footer>}
        </CheckCardContent>
      </Container>
    </ThemeProvider>
  );
};

const Container = styled('div')`
  display: flex;
  align-items: start;
  margin-bottom: 12px;
`;
const Header = styled('header')`
  display: flex;
  align-items: center;
`;
const CheckCardContent = styled('div')`
  padding-left: 16px;
  flex-grow: 1;
`;

const RightSide = styled('div')`
  margin-left: auto;
  display: flex;
`;

const Content = styled('div')`
  color: ${({ theme: { componentTheme } }) => componentTheme.Content.color};
  font-size: ${({ theme: { componentTheme } }) => componentTheme.Content.fontSize};
`;

const CheckboxWrapper = styled(Checkbox)`
  margin-top: 8px;
`;

const Footer = styled('div')`
  color: ${({ theme: { componentTheme } }) => componentTheme.Footer.color};
  font-size: ${({ theme: { componentTheme } }) => componentTheme.Footer.fontSize};
`;

CheckListItem.defaultProps = {
  className: null,
  disabled: false,
};

export default CheckListItem;
